import React, { useEffect, useState } from "react"
import { Search } from "lucide-react"
import { Input } from "src/components/ui/input"
import { Button } from "src/components/ui/button"
import { fetchVariables } from "../api/templatesApi"

// Searchable, grouped variable palette. Clicking a variable calls onInsert with
// the Liquid token (e.g. "{{ lead.first_name }}") for insertion at the cursor.
export function VariableInserter({ category, onInsert }) {
  const [groups, setGroups] = useState({})
  const [query, setQuery] = useState("")

  useEffect(() => {
    if (!category) return
    fetchVariables(category).then(setGroups).catch(() => setGroups({}))
  }, [category])

  const q = query.trim().toLowerCase()

  return (
    <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-slate-50/50">
      <div className="border-b border-slate-100 p-2">
        <div className="relative">
          <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search variables…"
            className="h-8 pl-8 text-[12px]"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2">
        {Object.entries(groups).map(([group, vars]) => {
          const filtered = vars.filter(
            (v) => !q || v.key.toLowerCase().includes(q) || v.label.toLowerCase().includes(q)
          )
          if (filtered.length === 0) return null
          return (
            <div key={group} className="mb-3">
              <p className="mb-1 px-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{group}</p>
              <div className="space-y-0.5">
                {filtered.map((v) => (
                  <Button
                    key={v.key}
                    type="button"
                    variant="ghost"
                    onClick={() => onInsert(`{{ ${v.key} }}`)}
                    title={`Insert {{ ${v.key} }}`}
                    className="flex h-auto w-full flex-col items-start justify-start gap-0 rounded-md px-2 py-1 text-left font-normal transition-colors hover:bg-white"
                  >
                    <span className="font-mono text-[11px] text-slate-700">{`{{ ${v.key} }}`}</span>
                    <span className="text-[10px] text-slate-400">{v.label}</span>
                  </Button>
                ))}
              </div>
            </div>
          )
        })}
        {Object.keys(groups).length === 0 && (
          <p className="px-1 text-[12px] text-slate-400">Pick a category to see variables.</p>
        )}
      </div>
    </div>
  )
}
